import { isNumber } from 'lodash'
import { createColVnode } from '../header/utils'
import { createHeaderBody } from '../header/header-tbody'
import { BORDER_VALUE, MAIN_TABLE, UPDATE_STORE_PARAMS } from '../../config'
import '../../style/virtual-grid.scss'

const HeaderTBody = createHeaderBody()

export function createFooter() {
  return {
    name: 'TableFooter',
    props: {
      columns: Array,
      width: Number,
      rowsLength: Number,
      rowHeight: Number,
      loadingRow: Boolean,
      type: String,
      store: Object,
    },
    computed: {
      isMainTable() {
        return this.$props.type === MAIN_TABLE
      },
      windowStyle() {
        let { width, rowsLength, rowHeight } = this.$props
        if (this.isMainTable) {
          width -= BORDER_VALUE
        }
        const tableStyle = {
          width: isNumber(width) ? `${width}px` : width,
          height: rowsLength * rowHeight + 'px',
        }
        return [
          {
            position: 'relative',
            overflow: 'hidden',
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform',
          },
          tableStyle,
        ]
      },
    },
    mounted() {
      this.isMainTable && this.updateFooterHeight()
    },
    beforeDestroy() {
      this.updateFooterHeight()
    },
    render(h) {
      const props = this.$props
      const { columns, rowsLength, rowHeight, loadingRow } = props
      const slots = this.$slots.default || []
      const footerSlot = slots[0]
      if (footerSlot && footerSlot.footer) {
        if (!this.isMainTable) return null
        return footerSlot.footer[0]
      }

      const isMainTable = this.isMainTable
      const colVnode = createColVnode(h, columns)

      const { horizontalVirtualRange } = this.store.states
      const { padFront: horizontalPadFront } = horizontalVirtualRange
      // 页脚不允许存在Y轴的滚动
      const paddingStyle = {
        position: 'absolute',
        transform: `translateX(${isMainTable ? horizontalPadFront : 0}px)`,
      }
      return (
        <div ref="tableFooter" style={this.windowStyle}>
          <div
            class="virtual-grid__footer-container virtual-grid__inner"
            style={paddingStyle}
          >
            <table class="virtual-grid__inner__table virtual-grid__footer__table">
              <colgroup>{colVnode}</colgroup>
              <HeaderTBody
                rowsLength={rowsLength}
                rowHeight={rowHeight}
                loadingRow={loadingRow}
              >
                {slots}
              </HeaderTBody>
            </table>
          </div>
        </div>
      )
    },
    methods: {
      scrollToLeft(left) {
        if (!this.$refs.tableFooter) return
        if (this.$refs.tableFooter.scrollLeft === left) return
        this.$nextTick(() => {
          this.$refs.tableFooter.scrollLeft = left
        })
      },
      updateFooterHeight() {
        const height = (this.$el && this.$el.offsetHeight) || 0
        this.store.commit(UPDATE_STORE_PARAMS, {
          scrollOffsetX: height,
          footerHeight: height
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/footer/index.js